import { useEffect, useState } from "react";
import Email from "./Email";
import VerificationCode from "./VerificationCode";
import { postAuthEmail } from "@/modules/auth/api/user/auth";
import { logger } from "@/shared/utils/logger";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [step, setStep] = useState<"email" | "code">("email");
  const [resendCooldown, setResendCooldown] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const startCooldown = () => {
    setResendCooldown(60);
  };

  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setInterval(() => {
        setResendCooldown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [resendCooldown]);

  const handleSubmit = async (email: string) => {
    setIsLoading(true);
    try {
      postAuthEmail({ email });

      setStep("code");
      startCooldown();

      setIsLoading(false);
    } catch (error) {
      logger.error("Failed to log:", error);
    }
  };

  const handleResend = async () => {
    if (resendCooldown > 0) return;
    const res = await postAuthEmail({ email });
    if (res) {
      startCooldown();
    }
  };

  const getBack = () => {
    setStep("email");
  };

  return (
    <>
      {step === "email" && (
        <Email
          email={email}
          onEmailChange={setEmail}
          onSubmit={handleSubmit}
          resendCooldown={resendCooldown}
          isLoading={isLoading}
        />
      )}
      {step === "code" && (
        <VerificationCode
          email={email}
          onBack={getBack}
          resendCooldown={resendCooldown}
          onResend={handleResend}
        />
      )}
    </>
  );
};

export default Auth;
